
function addLandingPage(client, store) {
  /* Create Indexes for Root Menu */


  let currentContext = JSON.parse(client.CurrentContext);
  let meetingObj = JSON.parse(client.MeetingContext);
  //console.log("Meeting context new : ",meetingObj);

  store.addMeetingIndex(meetingObj.MeetingRootId);
  store.addMeetingIndex(meetingObj.MeetingParentId);

  let parentIndex = store.getMeetingIndex(meetingObj.MeetingRootId);
  let localIndex = store.getMeetingIndex(meetingObj.MeetingParentId);

  let rootMenuObj = {
    ParentIndex : parentIndex,
    LocalIndex : localIndex,
    MeetingRootDN : (meetingObj.MeetingRootDN) ? meetingObj.MeetingRootDN : 'Public',
    MeetingParentDN : (meetingObj.MeetingParentDN) ? meetingObj.MeetingParentDN : 'Public',
    PrettyURL : null,
    Path : client.RootMeeting,
    LeftRole : client.ClientLeftRole,
    RightRole : client.ClientRightRole,
    LeftID : client.ClientLeft,
    RightID : client.ClientRight,
    LeftDN : 'Visitor-'+currentContext.grantItem.GrantLeftID.substring(currentContext.grantItem.GrantLeftID.length - 5, currentContext.grantItem.GrantLeftID.length - 1),
    RightDN : 'SimpliaHome',
    DisplayStatus : null,
    ClientRowID : client.Client,
    PermanentLink : true,
    MeetingContext : meetingObj,
    Type : 'Parent'
  };

 // store.addRootMenu(rootMenuObj);
  //addPublicLinks(client, store);
      //--old---addWhiteBoardMenu({}, store);
      //--old---addUploadMenu({}, store);
  //onLoad();
}

function addPublicLinks(client, store) {
   let meetingObj = JSON.parse(client.MeetingContext);

  let parentIndex = store.getMeetingIndex(meetingObj.MeetingRootId);
  let localIndex = store.getMeetingIndex(meetingObj.MeetingParentId);

  /* Public Links Folder */
  let rootMenuObj = {
    ParentIndex : parentIndex,
    LocalIndex : localIndex,
    MeetingRootDN : (meetingObj.MeetingRootDN) ? meetingObj.MeetingRootDN : 'Public',
    MeetingParentDN : (meetingObj.MeetingParentDN) ? meetingObj.MeetingParentDN : 'Public',
    PrettyURL : null,
    Path : 'Public',
    LeftRole : client.ClientLeftRole,
    RightRole : client.ClientRightRole,
    LeftID : client.ClientLeft,
    RightID : client.ClientRight,
    LeftDN : 'Public',
    RightDN : 'Links',
    DisplayStatus : null,
    ClientRowID : null,
    PermanentLink : true,
    MeetingContext : meetingObj,
    Type : 'Parent'
  };

  store.addRootMenu(rootMenuObj);

  /* WhiteBoard */

  let WhiteBoardLink = '_FFFFFFFFFFFFFF00001655139398859004_';
  let WhiteBoardName = 'WhiteBoard';
  rootMenuObj = newMenuObj(client, store, WhiteBoardLink, WhiteBoardName);  
  store.addRootMenu(rootMenuObj);

  /* Docs */

  let DocumentLink = '_FFFFFFFFFFFFFF00001657814745210148_';
  let DocumentName = 'Document';
  rootMenuObj = newMenuObj(client, store, DocumentLink, DocumentName);  
  store.addRootMenu(rootMenuObj);

  /* SpreadSheet */

  //let SpreadSheetLink = '_FFFFFFFFFFFFFF00001657907599809011_';
  let SpreadSheetLink = '_FFFFFFFFFFFFFF00001717698216474017_';
  let SpreadSheetName = 'SpreadSheet';
  rootMenuObj = newMenuObj(client, store, SpreadSheetLink, SpreadSheetName);  
  store.addRootMenu(rootMenuObj);

  /* Charts */

  /*let ChartLink = '_FFFFFFFFFFFFFF00001657911339163006_';
  let ChartName = 'Chart';
  rootMenuObj = newMenuObj(client, store, ChartLink, ChartName);  
  store.addRootMenu(rootMenuObj);
*/
  /* Scheduler */
  /*let SchedulerLink = '_FFFFFFFFFFFFFF00001657911339163010_';
  let SchedulerName = 'Scheduler';
  rootMenuObj = newMenuObj(client, store, SchedulerLink, SchedulerName);  
  store.addRootMenu(rootMenuObj);
*/
  /* Uploader */
  let UploadLink = '_FFFFFFFFFFFFFF00001661360655470009_';
  let UploadName = 'UploadFiles';
  rootMenuObj = newMenuObj(client, store, UploadLink, UploadName);  
  store.addRootMenu(rootMenuObj);
}

function newMenuObj(client, store, itemLink, itemName) {
  let meetingObj = JSON.parse(client.MeetingContext);
  let parentIndex = store.getMeetingIndex(meetingObj.MeetingRootId);
  let localIndex = store.getMeetingIndex(meetingObj.MeetingParentId);

  let rootMenuObj = {
    ParentIndex : parentIndex,
    LocalIndex : localIndex,
    MeetingRootDN : (meetingObj.MeetingRootDN) ? meetingObj.MeetingRootDN : 'Public',
    MeetingParentDN : (meetingObj.MeetingParentDN) ? meetingObj.MeetingParentDN : 'Public',
    PrettyURL : null,
    Path : 'Public/'+itemName,
    LeftRole : client.ClientLeftRole,
    RightRole : client.ClientRightRole,
    LeftID : itemLink,
    RightID : itemLink,
    LeftDN : 'Links',
    RightDN : itemName,
    DisplayStatus : null,
    ClientRowID : null,
    PermanentLink : true,
    MeetingContext : meetingObj,
    Type : 'Parent'
  };

  return rootMenuObj;
}


function addWhiteBoardMenu(rootMenu, store) {
  console.log("addWhiteBoardMenu Called");
  let Templates = window.LivingScript_0070.guid.generateSync();
  let WhiteBoardTemplate = '_FFFFFFFFFFFFFF00001655139398859004_';

  store.addMeetingIndex(Templates);
  let localIndex = store.getMeetingIndex(Templates);

  let TemplateMenu = {
    ParentIndex : localIndex,
    LocalIndex : localIndex,
    PrettyURL : null,
    Path : 'Templates',
    LeftRole : 'Visitor',
    RightRole : 'Visitor',
    LeftID : Templates,
    RightID : Templates,
    LeftDN : 'Templates',
    RightDN : 'Templates',
    DisplayStatus : null,
    ClientRowID : null,
    PermanentLink : true,
    Type : 'Parent'
  };
  store.addRootMenu(TemplateMenu);

  let WhiteBoardMenu = {
    ParentIndex : localIndex,
    LocalIndex : localIndex,
    PrettyURL : null,
    Path : 'Templates/WhiteBoard',
    LeftRole : 'Visitor',
    RightRole : 'Visitor',
    LeftID : WhiteBoardTemplate,
    RightID : WhiteBoardTemplate,
    LeftDN : 'Templates',
    RightDN : 'WhiteBoard',
    DisplayStatus : null,
    ClientRowID : null,
    PermanentLink : true,
    Type : 'Parent'
  };

  store.addRootMenu(WhiteBoardMenu);

  let SimpliaDocs = {
    ParentIndex : localIndex,
    LocalIndex : localIndex,
    PrettyURL : null,
    Path : 'Templates/Document',
    LeftRole : 'Visitor',
    RightRole : 'Visitor',
    LeftID : '_FFFFFFFFFFFFFF00001657814745210148_',
    RightID : '_FFFFFFFFFFFFFF00001657814745210148_',
    LeftDN : 'Templates',
    RightDN : 'Document',
    DisplayStatus : null,
    ClientRowID : null,
    PermanentLink : true,
    Type : 'Parent'
  };

  store.addRootMenu(SimpliaDocs);

  let SimpliaSheets = {
    ParentIndex : localIndex,
    LocalIndex : localIndex,
    PrettyURL : null,
    Path : 'Templates/SpreadSheet',
    LeftRole : 'Visitor',
    RightRole : 'Visitor',
    LeftID : '_FFFFFFFFFFFFFF00001657907599809011_',
    RightID : '_FFFFFFFFFFFFFF00001657907599809011_',
    LeftDN : 'Templates',
    RightDN : 'SpreadSheet',
    DisplayStatus : null,
    ClientRowID : null,
    PermanentLink : true,
    Type : 'Parent'
  };

  store.addRootMenu(SimpliaSheets);

  let GanttCharts = {
    ParentIndex : localIndex,
    LocalIndex : localIndex,
    PrettyURL : null,
    Path : 'Templates/GanttChart',
    LeftRole : 'Visitor',
    RightRole : 'Visitor',
    LeftID : '_FFFFFFFFFFFFFF00001657911339163006_',
    RightID : '_FFFFFFFFFFFFFF00001657911339163006_',
    LeftDN : 'Templates',
    RightDN : 'GanttChart',
    DisplayStatus : null,
    ClientRowID : null,
    PermanentLink : true,
    Type : 'Parent'
  };

  store.addRootMenu(GanttCharts);

  let Schedulers = {
    ParentIndex : localIndex,
    LocalIndex : localIndex,
    PrettyURL : null,
    Path : 'Templates/Scheduler',
    LeftRole : 'Visitor',
    RightRole : 'Visitor',
    LeftID : '_FFFFFFFFFFFFFF00001657911339163010_',
    RightID : '_FFFFFFFFFFFFFF00001657911339163010_',
    LeftDN : 'Templates',
    RightDN : 'Scheduler',
    DisplayStatus : null,
    ClientRowID : null,
    PermanentLink : true,
    Type : 'Parent'
  };

  store.addRootMenu(Schedulers);
}

function addUploadMenu(rootMenu, store) {
  let uploadTip = '_FFFFFFFFFFFFFF00001661360655470009_';

  store.addMeetingIndex(uploadTip);
  let localIndex = store.getMeetingIndex(uploadTip);

  let UploadMenu = {
    ParentIndex : localIndex,
    LocalIndex : localIndex,
    PrettyURL : null,
    Path : 'UploadToS3',
    LeftRole : 'Visitor',
    RightRole : 'Visitor',
    LeftID : uploadTip,
    RightID : uploadTip,
    LeftDN : 'UploadFiles',
    RightDN : 'UploadFiles',
    DisplayStatus : null,
    ClientRowID : null,
    PermanentLink : true,
    Type : 'Parent'
  };
  store.addRootMenu(UploadMenu);
}

function onLoad() {
  if(window.window.LivingScript_0070.context.urlContext) {
    let initialContext = window.window.LivingScript_0070.context.urlContext;

    if (typeof window.window.LivingScript_0070.context.urlContext === "string") {
      try {
          initialContext = JSON.parse(window.window.LivingScript_0070.context.urlContext);
      } catch(e) {
          console.log("Invalid urlContext");
      }
    }

    console.log("Got LivingScriptInit URL Context Parsed", initialContext);
    if(initialContext.onLoad && initialContext.onLoad.length > 0) {
      initialContext.onLoad.forEach((action) => {
        if(action.open) {
          console.log("onLoad Action Open : ", action.open);
          if(window.devStore && window.devStore.rootMenu) {
            window.BotServices.PullRootMenu(window.devStore.rootMenu[0]);
          } else {
            console.log("window.devStore.rootMenu not ready");
          }
        }

        console.log("onLoad Action", action);
        if(action.alert) {
          console.log("onLoad Action Alert : ", action.alert);
          let Client = window.botStore.getClientByID(window.LivingScript_0070.context.clientNodeId);
          window.BotServices.openAlert({Event : action.alert, Client : Client}, ()=>{});
        }

        if(action.signup) {
          if(window.botStore.attributions && window.botStore.attributions.length > 0) {
             console.log("Already LoggedIn");
          } else {
            let simpliaLoginModal = document.getElementById('simplia-Signin');
            simpliaLoginModal._instance.exposed.modalOpen();
            window.LivingScript_0070.context.onLoadaction = action;
          }
        }
      });
    }

    if(initialContext.Streamer) {
      let streamerContext = initialContext.Streamer;
      streamerContext.clientNodeId = window.LivingScript_0070.guid.generateSync();
      streamerContext.componentId = streamerContext.clientNodeId;
      window.botStore.addContext(streamerContext);
      setTimeout(() => {
        let CallPE = null;
        let InitialContext = {Caller:{Audio:false,NoShow:true,Screen:false,Video:true},Callee:{Audio:false,NoShow:true,Screen:false,Video:false},Calltype:"JOINCALL",Label:"Invite"};
        let callObj = {Mode:"STARTMEDIA" ,ClientID:streamerContext.clientNodeId,DialTimeout:60,CallPE:CallPE,InitialContext:InitialContext,isSignedIn: false};
        window.BotServices.startCall(callObj);
      }, 3000);
    }
  }
}

export {
  addWhiteBoardMenu,
  addLandingPage
}
